import { TextField } from "@mui/material";

export const PrefixInput = ({ value, onChange }) => (
  <TextField
    id="witness-prefix-input"
    label="Prefijo (encima de los testigos)"
    placeholder="Ejemplo: Fuentes de consulta"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    size="small"
    fullWidth
    inputProps={{ maxLength: 200 }}
  />
);